import { SpacingPresetOptions } from '../../theme';

export const spacingBase = 16;

export const spacing = {
  xs: `${spacingBase * 0.25}px`,
  sm: `${spacingBase * 0.5}px`,
  md: `${spacingBase}px`,
  lg: `${spacingBase * 2}px`,
  xl: `${spacingBase * 3}px`,

  inset: {
    xs: `${spacingBase * 0.25}px ${spacingBase * 0.5}px`,
    sm: `${spacingBase * 0.5}px ${spacingBase}px`,
    md: `${spacingBase}px ${spacingBase}px`,
    lg: `${spacingBase}px ${spacingBase * 2}px`,
    xl: `${spacingBase * 2}px ${spacingBase * 3}px`,
  },
  grid: {
    xs: `0 ${spacingBase * 0.25}px ${spacingBase * 0.25}px 0`,
    sm: `0 ${spacingBase * 0.5}px ${spacingBase * 0.5}px 0`,
    md: `0 ${spacingBase}px ${spacingBase}px 0`,
    lg: `0 ${spacingBase * 2}px ${spacingBase * 2}px 0`,
    xl: `0 ${spacingBase * 3}px ${spacingBase * 3}px 0`,
  },
  stack: {
    xs: `0 0 ${spacingBase * 0.25}px 0`,
    sm: `0 0 ${spacingBase * 0.5}px 0`,
    md: `0 0 ${spacingBase}px 0`,
    lg: `0 0 ${spacingBase * 2}px 0`,
    xl: `0 0 ${spacingBase * 3}px 0`,
  },
} as SpacingPresetOptions;
